/* global angular */

(function() {
    "use strict";

    var app = angular.module('app');

    app.controller('FormCtrl', ['$scope', function ($scope) {
        function save(form) {
            if (form.$error && form.$error.required) {
                var tops = form.$error.required.map(function (error) {
                    var element = error.$$element;
                    if (element) {
                        var node = element[0];
                        if (node.getAttribute('type') === 'hidden') {
                            node = node.parentNode;
                        }
                        // console.log(error, node);
                        return node.getBoundingClientRect().top;
                    }
                });
                var top = Math.min.apply(this, tops);
                $scope.$root.$broadcast('onScrollbarShouldScrollTo', {
                    x: 0,
                    y: (top - 25),
                    selector: 'page',
                });
                return false;
            }
            return true;
        }
        $scope.save = save;
    }]);

    app.directive('subForms', [function() {
        return {
            require: 'form',
            link: function (scope, element, attributes, form) {
                // console.log('subForms.link', form);
                scope.$watch(function () {
                    return form.$submitted;
                }, function (value) {
                    // console.log('form.$submitted', value);
                    if (value) {
                        angular.forEach(form, function (sub, key) {
                            if (sub && sub.$$parentForm === form) {
                                // console.log(typeof (sub.$setSubmitted), sub.$name);
                                if (typeof (sub.$setSubmitted) === 'function') {
                                    try {
                                        sub.$setSubmitted(value);
                                        // console.log(sub);
                                    } catch (e) {
                                        console.log('sub.$setSubmitted', sub.$name, sub, value, e);
                                    }
                                }
                            }
                        });
                    }
                });
            }
        };
    }]);

}());